export default __webpack_public_path__ + "static/iqcartoes-c773c00fdfb4b854f1a48e345ac69501.png";